import { defaultHeight } from "@/components/CellGrid/cell/Wrapper";
import { useInViewport } from "@mantine/hooks";
import { ReactNode } from "react";

export const RenderWhenInView = ({
  children,
  height = defaultHeight,
}: {
  children: ReactNode;
  height?: number;
}) => {
  const { ref, inViewport } = useInViewport();
  return (
    <div ref={ref} style={{ height }}>
      {inViewport && children}
    </div>
  );
};
